export const RECOMMENDATION_ANALYTICS_ATTR_IMAGE = 'item-image'
export const RECOMMENDATION_ANALYTICS_ATTR_TITLE = 'item-title'
